import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  height: "48",
  width: "48",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M.576,2.285A.338.338,0,0,0,.5,2.493V7.556a.345.345,0,0,0,.222.323l4.154,1.6A.354.354,0,0,0,5,9.5V3.986Z",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.424,2.285,5,3.986V9.5a.354.354,0,0,0,.124-.023l4.154-1.6A.345.345,0,0,0,9.5,7.556V2.493A.338.338,0,0,0,9.424,2.285Z",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M.576,2.285,5,3.986l4.424-1.7a.339.339,0,0,0-.146-.115L5.124.523a.342.342,0,0,0-.248,0L.722,2.17A.339.339,0,0,0,.576,2.285Z",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }